// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"a8aba599","234":"a8ea8c53","356":"a8ea8c53","739":"5aa9ff7c"}[chunkId] + ".chunk.css";
};